export var BrandResponsibility = function BrandResponsibility(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getDescription();
    }
  };
};
var brandResponsibilityBuilder = function brandResponsibilityBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "Dg58Ac",
        defaultMessage: [{
          "type": 0,
          "value": "Regulamentos sobre o envio internacional"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "hjwQzs",
        defaultMessage: [{
          "type": 0,
          "value": "Todas as marcas que vendem na Faire são responsáveis pelo cumprimento de todas as leis, normas e regulamentos em todos os países e regiões onde escolhem vender os seus produtos através da Faire."
        }]
      }), strictLocalize({
        id: "ujgpuX",
        defaultMessage: [{
          "type": 0,
          "value": "Isto inclui, entre outros: segurança dos produtos, requisitos de etiquetas, testes, avisos, direitos de autor, regulamentos de importação e exportação e qualquer outro requisito legal de proteção do consumidor."
        }]
      }), strictLocalize({
        id: "DAIwfn",
        defaultMessage: [{
          "type": 0,
          "value": "Para confirmar se os seus produtos podem ser vendidos noutros países ou regiões, consulte um despachante aduaneiro ou um consultor jurídico."
        }]
      })];
    }
  };
};